<template>
  <div
    v-if="show"
    class="modal-backdrop d-flex justify-content-center align-items-center"
  >
    <div class="modal-content p-4 rounded shadow">
      <h3 class="mb-3 text-center">Set a New Password</h3>
      <input
        type="password"
        v-model="newPassword"
        placeholder="New Password"
        class="form-control mb-3"
      />
      <p class="text-xsm text-danger">{{ errorMessage }}</p>
      <button class="btn btn-primary w-100" @click="resetPassword">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/globals";

export default {
  name: "ForcePasswordResetModal",
  props: ["show"],
  data() {
    return {
      newPassword: "",
      errorMessage: "",
    };
  },
  methods: {
    async resetPassword() {
      try {
        if (this.newPassword.trim().length < 6) {
          this.errorMessage = "New password must be at least 6 characters long"
          return 
        }
        const token = this.$store.getters.token;
        const response = await axios.patch(
          `${BASE_URL}/api/auth/reset-password`,
          {
            newPassword: this.newPassword,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.status) {
          this.$store.dispatch("logout");
          this.$router.push("/login")
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          this.errorMessage = response.data.message
        }
      } catch (err) {
        alert("Failed to reset password");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}
.modal-content {
  background-color: #fff;
  max-width: 400px;
  width: 100%;
}
</style>

